import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import ar from './locales/ar.json'

export type Locale = 'ar' | 'en'

const STORAGE_KEY = 'tlaaq_locale'
const DEFAULT_LOCALE: Locale = 'ar'

function readStoredLocale(): Locale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE
  const stored = window.localStorage.getItem(STORAGE_KEY)
  return stored === 'ar' || stored === 'en' ? stored : DEFAULT_LOCALE
}

const initial = readStoredLocale()

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

applyDocumentDirection(initial)

export function setLocale(locale: Locale): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, locale)
  }
  void i18n.changeLanguage(locale)
  applyDocumentDirection(locale)
}

export function getLocale(): Locale {
  return (i18n.language as Locale) || DEFAULT_LOCALE
}

function applyDocumentDirection(locale: Locale): void {
  if (typeof document === 'undefined') return
  document.documentElement.dir = locale === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = locale
}

export default i18n
